import { Checkbox } from '@base-ui/react';
import { Icon } from '@components/icon/Icon';
import styles from './GuestSelectionCheckbox.scss';

export const GuestSelectionCheckbox = ({
  id,
  className,
  onChange,
  children,
  checked,
}: {
  id: string;
  className?: string;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
  checked: boolean;
}) => {
  const identifier = `multi-selection-checkbox-${id}`;

  return (
    <label htmlFor={identifier} className={className}>
      <Checkbox.Root
        aria-label={`Selector for guest ${id}`}
        id={identifier}
        checked={checked}
        onCheckedChange={onChange}
        className={styles.checkbox}
      >
        <Checkbox.Indicator className={styles.indicator}>
          <Icon name="checkMark" className={styles.icon} />
        </Checkbox.Indicator>
      </Checkbox.Root>
      {children}
    </label>
  );
};
